import { AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { MyrAPIService } from '../../../api/myr/myrAPI';
import { IReduxRootState } from '../../../app/reduxRootState.interface';
import { ErrorResolution } from '../../../app/common/errorResolution/errorResolution';
import { ErrorResolutionActions } from '../../../app/common/errorResolution/errorResolutionActions';
import { NotificationsActions } from '../../../app/common/notifications/notificationsActions';
import { NotificationAction } from '../../../app/common/notifications/notificationsActionType';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import IdentityVerificationActions from '../identityVerificationActions';
import { EkycServiceAction, EkycServiceActionType } from './ekycServiceActionType';
import { IEkycServiceRequest } from './ekycServiceRequest';
import { MyrAPIEndpoints } from '../../../api/myr/myrAPIEndpoints.constant';
import { loginActions } from '../../../login/login.actions';
import { history } from '../../../utils/history';

export class EkycServiceActions {
    public static unlinkEKYCService(
        values: IEkycServiceRequest,
    ): ThunkAction<void, IReduxRootState, {}, AnyAction> {
        return (
            dispatch: ThunkDispatch<IReduxRootState, {}, AnyAction>,
            getState: () => IReduxRootState,
        ) => {
            dispatch(request());
            const { clientId, ...data } = values;

            return MyrAPIService.sendRequest(
                `${MyrAPIEndpoints.EKYC}/${clientId}`,
                'DELETE',
                data,
                '',
                'json',
            )
                .then((response: any) => success(dispatch, getState))
                .catch((errorResolution: any) => failure(dispatch, errorResolution));
        };

        function request(): EkycServiceAction {
            return {
                payload: {},
                type: EkycServiceActionType.UNLINK_EKYCSERVICE_REQUEST,
            };
        }

        function success(
            dispatch: ThunkDispatch<IReduxRootState, {}, AnyAction>,
            getState: () => IReduxRootState,
        ) {
            const { clientId } = values;
            dispatch({
                payload: { clientId },
                type: EkycServiceActionType.UNLINK_EKYCSERVICE_SUCCESS,
            });
            dispatch(
                NotificationsActions.showSuccess(
                    TranslationHelpers.getFormattedMessage('notifications.ekyc.unlink.success'),
                ),
            );
            dispatch(IdentityVerificationActions.closeIdentityVerificationOverlay());
            const state = getState();
            const linkedServices = state.identityVerification.linkedServices.filter(
                (service) => service.clientId !== clientId,
            );
            if (linkedServices.length === 0) {
                dispatch(loginActions.getMember());
                history.push('/');
            }
        }

        function failure(
            dispatch: ThunkDispatch<
                IReduxRootState,
                {},
                EkycServiceAction | NotificationAction | AnyAction
            >,
            errorResolution: ErrorResolution,
        ) {
            console.log('ErrorResolution', errorResolution);
            dispatch({
                payload: { errorResolution },
                type: EkycServiceActionType.UNLINK_EKYCSERVICE_FAILURE,
            });
            dispatch(
                ErrorResolutionActions.processErrorResolution(
                    errorResolution,
                    'notifications.ekyc.unlink.failure',
                ),
            );
        }
    }
}
